import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from './../../../../lib/constants/reference-data-labels';

@Component({
  selector: 'boi-part-and-part-control',
  templateUrl: './part-and-part-control.component.html',
  styleUrls: ['./part-and-part-control.component.scss']
})
export class PartAndPartControlComponent {
  @Input() interestOnlyPart: number;
  @Output() readonly interestOnlyPartChange = new EventEmitter<number>();
  @Input() repaymentPart: number;
  @Input() totalLoan: number;
  @Input() isReadOnly: boolean;
  @Input() isKfi = false;
  public referenceDataLabels = ReferenceDataLabels;
}
